module.exports = __webpack_public_path__ + "images/cd96a15f3e79169819b76272a41d7b7c.woff2";


//////////////////
// WEBPACK FOOTER
// ./app/assets/fonts/EstrangeloNisibin.woff2
// module id = 1154
// module chunks = 0